export interface AnalyticsErrorEventInputModel {
  errorType: 'backend' | 'form' | 'input' | 'generic';
  errorCode: string;
  errorMessage: string;
  errorField?: string;
  isFatal: boolean;
}
